import axios from "axios";

import * as Utility from "../common/utility";
import * as URL from "./url_helper";
import { refreshToken } from "http/auth/refreshToken";

const axiosApi = axios.create({
    baseURL: URL.API_URL,
  });
  
  let isRefreshing = false;
  let failedQueue = [];
  
  const processQueue = (error, token = null) => {
    failedQueue.forEach(prom => {
      error ? prom.reject(error) : prom.resolve(token);
    });
    failedQueue = [];
  };
  
  const getDifferenceInSeconds = (expiresDateTime, currentDateTime) => {
    return (expiresDateTime - currentDateTime) / 1000;
  };
  
  axiosApi.interceptors.request.use(
    async (config) => {
      if (config.skipInterceptor) return config;
  
      const tokenData = await Utility.getToken();
  
      if (!tokenData || !tokenData.access || !tokenData.refresh) {
        // handle missing token data if necessary
        throw new Error("Invalid token data");
      }
  
      const refreshThreshold = parseInt(process.env.REACT_APP_TOKEN_REFRESH_THRESHOLD, 10) || 60;
      const expiresDateTime = new Date(tokenData.access.expires);
      const currentDateTime = new Date();
      const differenceInSeconds = getDifferenceInSeconds(expiresDateTime, currentDateTime);
  
      if (differenceInSeconds < refreshThreshold && differenceInSeconds > 0) {
        if (!isRefreshing) {
          isRefreshing = true;
          refreshToken({ refresh_token: tokenData.refresh.token })
            .then(res => {
              localStorage.setItem('tokens', JSON.stringify(res));
              isRefreshing = false;
              processQueue(null, res.access.token);
            })
            .catch(err => {
              processQueue(err, null);
              return Promise.reject(err);
            });
        }
  
        return new Promise((resolve, reject) => {
          failedQueue.push({ resolve, reject });
        }).then(token => {
          config.headers["Authorization"] = "Bearer " + token;
          return config;
        });
  
      } else {
        config.headers["Authorization"] = "Bearer " + tokenData.access.token;
        return config;
      }
    },
    (error) => {
      return Promise.reject(error);
    }
  );
  
  axiosApi.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error?.response?.status === 401) {
        localStorage.clear();
        window.dispatchEvent(new CustomEvent("unauthorized"));
      } 
      else if (error?.response?.status === 403) {
        window.dispatchEvent(new CustomEvent("forbidden"));
      }
      else 
      {
        return Promise.reject(error);
      }
    }
  );

export async function get(url, page, limit, config = {}) {
  config.params = { ...config.params, page, limit };
  return await axiosApi
    .get(url, { ...config })
    .then((response) => response?.data)
    .catch((error) => error);
}

export async function post(url, data, config = {}) {
  return axiosApi
    .post(url, data, { ...config })
    .then((response) => response.data)
    .catch((error) => {
      return error?.response?.data;
    });
}

export async function put(url, data, config = {}) {
  return axiosApi
    .put(url, { ...data }, { ...config })
    .then((response) => response?.data);
}

export async function del(url, config = {}) {
  return await axiosApi
    .delete(url, { ...config })
    .then((response) => response?.data);
}

export async function all(listRequest) {
  return await Promise
    .all(listRequest)
    .then((response) => response);
}
